import {requestOrder,requestThirdPart,requestBase,requestProduct } from '@/utils/request'

export function settlementOrderByTimeAsync(data) {
  return requestOrder({
    url: `/order/platform/settlementOrderByTimeAsync`,
    method: 'post',
    data
  })
}
// 获取物流费计算规则
export function getExpressFeeByWarehouseCode(data) {
  return requestProduct({
    url: '/warehouseExpress/getExpressFeeByWarehouseCode',
    method: 'post',
    data
  });
}
// 取消订单申请详情
export function orderCancelApplicationSelectOne(data) {
  return requestOrder({
    url: '/orderCancelApplication/selectOne',
    method: 'post',
    data
  })
}
export function listInsuranceByOrderSn(data) {
  return requestOrder({
    url: '/order/insurance/listInsuranceByOrderSn',
    method: 'post',
    data
  })
}

export function confirmCircleOrder(data) {
  return requestOrder({
    url: '/order/platform/confirmCircleOrder',
    method: 'post',
    data
  })
}

export function fetchList(data) {
  return requestOrder({
    url: '/order/shop/list',
    method: 'post',
    data
  })
}
// 查询物流轨迹
export function queryTrack(data) {
  return requestThirdPart({
    url: `/tracking/track/query`,
    method: 'post',
    data
  })
}
// 创建出库单接口
export function createOrderToERP(data) {
  return requestThirdPart({
    url: `/erp/createOrderToERP`,
    method: 'post',
    data
  })
}
// 根据订单id查询订单推送仓储系统状态
export function queryPushToWarehouseStatus(data) {
  return requestThirdPart({
    url: `/erp/queryPushToWarehouseStatus`,
    method: 'post',
    data
  })
}
// 订单日志
export function OrderLogRecord(data) {
  return requestOrder({
    url: '/order/statusRecord/query',
    method: 'post',
    data
  })
}

// 退款日志
export function RefundRecordLog(data) {
  return requestOrder({
    url: '/order/refundRecord/query',
    method: 'post',
    data
  })
}

// 查询圈货单订金比例
export function ReservationFeeRatio(data) {
  return requestOrder({
    url: '/order/mall/reservationFeeRatio',
    method: 'post',
    data
  })
}
// 退货列表
export function returnPlatPage(data) {
  return requestOrder({
    url: '/return/platPage',
    method: 'post',
    data
  })
}
// 退货日志
export function returnStatusRecord(data) {
  return requestOrder({
    url: '/returnStatusRecord/selectListByReturnId',
    method: 'post',
    data
  })
}

// 查询退货地址
export function orderReceiverAddressSelectOne(data) {
  return requestOrder({
    url: '/orderReceiverAddress/selectOne',
    method: 'post',
    data
  })
}

// 退货详情
export function returnGetOne(data) {
  return requestOrder({
    url: '/return/selectOne',
    method: 'post',
    data
  })
}

// 退款详情
export function refundSelectOne(data) {
  return requestOrder({
    url: '/refund/selectOne',
    method: 'post',
    data
  })
}

// 订单查询商品详情
export function orderItemList(data) {
  return requestOrder({
    url: '/orderItem/list',
    method: 'post',
    data
  })
}

// 获取对应的订单配置
export function orderFindSetting(data) {
  return requestOrder({
    url: '/orderSetting/findSetting',
    method: 'post',
    data
  })
}

// 修改订单配置
export function orderSaveOrUpdateSetting(data) {
  return requestOrder({
    url: '/orderSetting/saveOrUpdateSetting ',
    method: 'post',
    data
  })
}

// 订单编号获取详情
export function mallGetByOrderSn(data) {
  return requestOrder({
    url: '/order/mall/getByOrderSn',
    method: 'post',
    data
  })
}

// 订单详情列表查询-根据仓库分级
export function orderItemWarehouseLevelList(data) {
  return requestOrder({
    url: '/orderItem/warehouseLevelList',
    method: 'post',
    data
  })
}

// 获取退货运费
export function getReturnDeliveryFee(data) {
  return requestOrder({
    url: '/return/getReturnDeliveryFee',
    method: 'post',
    data
  })
}

// 平台仲裁
export function returnPlatformUpdate(data) {
  return requestOrder({
    url: '/return/platformUpdate',
    method: 'post',
    data
  })
}

// 获取订金等级配置
export function getPreOrderConfig(data) {
  return requestOrder({
    url: '/config/getPreOrderConfig',
    method: 'post',
    data
  });
}

// 退货标签列表
export function productLabelFind(data) {
  return requestBase({
    url: '/manager/product/label/find',
    method: 'post',
    data
  });
}
// 退货标签列表  新
export function providerList(data) {
  return requestBase({
    url: '/manager/logistics/provider/list',
    method: 'post',
    data
  });
}
// 改变退货标签状态
export function selectReturnLabel(data) {
  return requestBase({
    url: '/manager/logistics/provider/selectReturnLabel',
    method: 'post',
    data
  });
}
//
export function productLabelSelect(data) {
  return requestBase({
    url: '/manager/product/label/select',
    method: 'post',
    data
  });
}
/**
 * 确认收货
 * @param {orderId} 订单ID
 */
export function confirmReceive(data) {
  return requestOrder({
    url: `/order/mall/confirmReceiveOrder`,
    method: 'post',
    data
  });
}

//连接quickbooks
export function connectToQuickBooks() {
  return requestOrder({
    url: "/qbo/connectToQuickBooks",
    method: "post",
  });
}

export function orderCancelApplicationPlatformPage(data) {
  return requestOrder({
    url: "/orderCancelApplication/platformPage",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/order.js